export default "__VITE_ASSET__C6oDdvs$__"